export const listMutations = <const>{
	OJETE_VOZY_TYP_KOD_FILTER_SELECT_MAPPER: 'OJETE_VOZY_TYP_KOD_FILTER_SELECT_MAPPER',
};

export const editMutations = <const>{
	OJETE_VOZY_TYP_KOD_SELECT_MAPPER: 'OJETE_VOZY_TYP_KOD_SELECT_MAPPER',
};
